export const countProductsInSections = (sections) => (
  sections
    .map(section => section.fops.length)
    .reduce((a, b) => (a + b), 0)
);

export const countProductsInFopCollection = (fopCollection) => (
  fopCollection && fopCollection.sections
    ? countProductsInSections(fopCollection.sections)
    : 0
);
